import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select   from 'react-select'
import {v4 as uuidv4}  from 'uuid'
import formatNumbers  from 'util/formatNumbers';
import moment from 'moment'
import ContractorTransactionsActionsBox from 'dashboard/userData/contractorTransactions/ContractorTransactionsActionsBox'
import ContractorTransactionsSearchBox from 'dashboard/userData/contractorTransactions/ContractorTransactionsSearchBox'
import ContractorTransactionsListTable from'dashboard/userData/contractorTransactions/ContractorTransactionsListTable';
import {makeRequest, getErrorMessage, dispatchAction, displayMessage}  from 'actions';
import {
    FETCH_TRANSACTIONS, UPDATE_TRANSACTION, RESET_TRANSACTIONS, DELETE_TRANSACTION,
    CLEAR_SELECTED_TRANSACTIONS, FETCH_ALL_SELLERS_LIST, ADD_TRANSACTION
} from "actions/actionTypes";
  import config from  '../../../../config';
import queryString from 'query-string'
import {fetchAllSellersList,fetchAllContractorsList}  from 'shared/sharedMethods';
 import PaginationBox from'shared/PaginationBox';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
 import RemoveModalDialog from'shared/RemoveModalDialog';

var async = require('async');
var transactionTypes = [
    {value: 'Sale', label: 'Sale'},
    {value: 'Fee', label: 'Fee'},
    {value: 'PickupFee', label: 'Pickup Fee'},
    {value: 'Credit', label: 'Credit'},

];
import {prepareSelectOptionsList,convertToHoursAndMinutes} from 'util/Utils';
var TransactionsSearchBox ,TransactionsActionsBox ,TransactionsListTable
class TransactionsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            errors: {},
            currentRecordID: false,
            PayoutNote: '',
            totalDuration: 0,
            selectAllRecords: false,
            pending: false,
            formData: {
                Description: '',
                Seller: false,
                Type: '',
                Amount: '',
                selectedProduct: {},
                Status: '',
                sellerProducts: [],
                OrderID: '',
             },
            currentRecord: false,
            showAddFeeModal: false,
            sortBy: '',
            selectedUser: false,
            displayGeneratePayoutBox: false,
            ContractorID: this.props.adminTransactions.ContractorID,
            sendEmailToUser: false,

        };
        this.searchBox = false;



    };

    componentWillMount() {
        if (_.size(this.props.allContractorsList.data) ==0) {
            fetchAllContractorsList.call(this)
        }
             this.setState({contractorsOptionsList :prepareSelectOptionsList(_.filter(this.props.allContractorsList.data, {Status:'Active'}), {
                label: 'UserFullName',
                value: '_id',
                customOptionFields:[
                    {fieldName:'Type', path:'Type'},
                ]
            })})


    }

    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allContractorsList.data) !== _.size(this.props.allContractorsList.data)) {

                this.setState({contractorsOptionsList :prepareSelectOptionsList(_.filter(nextProps.allContractorsList.data, {Status:'Active'}), {
                    label: 'UserFullName',
                    value: '_id',
                    customOptionFields:[
                        {fieldName:'Type', path:'Type'},
                    ]
                })})


        }
    }

    resetSearch() {
        this.props.dispatchAction({}, RESET_TRANSACTIONS)
        this.setState({
            ContractorID: false,
            sortBy: '',
            displayGeneratePayoutBox: false
        });
    }

    setSearchParams(params) {
        this.searchBox.setSearchParams(params);
    }

    fetchSelectedUserData(UserID) {
        if (!UserID) {
            this.setState({selectedUser: false})
            return;
        }


        var methodData = {
            'endpoint':  '/contractors/' + encodeURIComponent(UserID),
            'not_display_success_message': true
        };

        return this.props.makeRequest({}, methodData).then(function (res) {
            this.setState({selectedUser: res.data})
        }.bind(this)).catch(err => {
            this.setState({selectedUser: false})
        });
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
         var {queryParams} = this.searchBox.getSearchParams();
        _.extend(queryParams, params);
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary  = '_id:-1'; /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        }
        if (queryParams.ContractorID) {
            queryParams.all = true;
            this.setState({ContractorID: queryParams.ContractorID});

        } else { /* when selecting 'all' sellers */
            this.setState({ContractorID: false});
        }

        var methodData = {
            "endpoint": "/transactions",
            'not_display_success_message': true
        };
        if (_.isUndefined(params.include)) {
            methodData['success_event'] = FETCH_TRANSACTIONS;

            methodData['success_event_data'] = {
                'ContractorID': queryParams.ContractorID ? queryParams.ContractorID : false,
            }
        }
        if (_.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
            this.setState({displayGeneratePayoutBox: false, PayoutNote: ''});
        }

        if (queryParams.page == 1) {
            queryParams.page = undefined;
        }
        queryParams.lookup= ['Contractors', 'Users']
        const stringified = queryString.stringify(_.omit(queryParams, ['include','page', 'lookup','Types', 'all','sortBySecondary']));
        this.context.router.push( '/admin/time-tracking-registry?' + stringified);
        return this.props.makeRequest(queryParams, methodData).then(function (res) {

            var TotalTimeLogsDuration = _.reduce(_.get(res.data, 'data', []), function (total, item) {
                total += _.get(item, ['CustomData', 'TotalTimeLogsDuration'],0)
                return total
            }, 0)
            var timeLogsTotalTime = moment.duration(TotalTimeLogsDuration);
            var totalDuration = convertToHoursAndMinutes(timeLogsTotalTime, {format: 'hours_and_minutes'})
            this.setState({
                pending:false, totalDuration: totalDuration
            })
            return res;
        }.bind(this)).catch(err => {
            this.setState({pending:false})
        });

    }

    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({selectAllRecords: true});
        } else {
            this.setState({selectAllRecords: false});
        }
    }

    deleteTransaction(row) {
        var self = this
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'patch',
            "endpoint": "/transactions/updateDeleted/" + encodeURIComponent(this.state.currentRecord._id),
            'success_event_data': {
                'TransactionID': this.state.currentRecord._id
            },
            messageCode: 'Transaction has been set as Deleted'
        };
        this.setState({currentRecord: false});
        this.props.makeRequest({}, methodData).then(function () {
            self.search()
        }).catch(err => {
            console.log('in err', err);
        });
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }
unsubmitTimeLogs(row){
    this.setState({pending: true});
    var self = this;
    self.props.makeRequest({
        action: 'UnsubmitTimeLogs',
        transactionID: row._id,
    }, {
        type: 'post',
        timeout: 25000,
        'endpoint': '/users_data_process',
        not_display_success_message: true,
     }).then(function (res) {
        self.setState({pending: false});
        self.search()
        self.props.displayMessage({
             'messageCode': 'Working time logs were set as Pending'
        });
    }).catch(err => {
        self.setState({pending: false});

    });
}
    editTransaction(row) {
        this.onFormSellerChange({value: row.ContractorID._id});
        this.setState({
            showAddFeeModal: true,
            currentRecordID: row._id,
            formData: {
                Description: row.Description,
                Status: row.Status,
                Seller: row.ContractorID._id,
                Type: row.Type,
                Amount: row.Amount,
                selectedProduct: row.ProductID ? row.ProductID._id : {},
                sellerProducts: [],
             }
        });
    }

    checkPaidTransactions() {
        var paidTransactionsFound = false;
        _.forEach(this.props.adminTransactions.selectedTransactions, function (recordID, index) {
            var transaction = _.find(this.props.adminTransactions.data, function (item) {
                return item._id == recordID;
            })
            if (_.isUndefined(transaction)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Selected transaction is not found and not included in Total payout'
                });
                paidTransactionsFound = true;
            }
            if (transaction.Status == 'Paid') {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Transaction is already Paid'
                });
                paidTransactionsFound = true;
            }
        }.bind(this))
        return paidTransactionsFound;
    }

    completePayout() {
        this.setState({pending: true});
        var self = this;
        if (this.checkPaidTransactions()) {
            this.setState({pending: false});
            return false;
        }


        const PayoutID = uuidv4();
        const maximumTransactionsNumber =config.getEnvironmentName() == 'local' ? 100 : 5000;


        var functionsToPerform = [], totalPayout = self.calculateTotalPayout();

        if (totalPayout <= 0) {
          return  self.props.displayMessage({
                'messageType': 'success',
                'messageCode': 'Payout amount is not valid ' + totalPayout
            });
        }

            functionsToPerform.push(function (done) {
                var methodData = {
                    "endpoint": "/transactions/process_payout_payment",
                    not_display_success_message: true,
                    "type": 'post'
                };
                var error = false, transactionsData =[]
                _.forEach(self.props.adminTransactions.selectedTransactions, selectedTransactionID=>{
                    var data = { _id:selectedTransactionID }
                    var transaction = _.find(self.props.adminTransactions.data, function (item) {
                        return item._id == selectedTransactionID;
                    })
                    if (_.isUndefined(transaction)) {
                        error ={
                            'messageType': 'warning',
                            'messageCode': 'Selected transaction not found'
                        }
                        return false
                    }

                    transactionsData.push(data)
                })
                if (error){
                    self.props.displayMessage(error)
                    return done(true)
                }
                var params = {
                    payoutType:'WorkingTime',
                    PayoutID: PayoutID,
                    totalPayout: formatNumbers.toFixed(totalPayout, 2),
                     transactionsData: transactionsData,
                };
                if (self.props.adminTransactions.selectedTransactions.length  > maximumTransactionsNumber) {
                    if (self.state.sendEmailToUser) {
                        params.sendEmailToUser = true;
                    }
                    params.processInBackground =true
                }
                self.props.makeRequest(params, methodData).then(function (res) {
                    done(null)
                }).catch(err => {
                    if (!(self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber)) {
                        self.props.displayMessage({
                            'messageType': 'warning',
                            messageCode: 'sellerPayoutConfirmationNotSent'
                        });
                    }
                    done(err)
                });
            })
        if (!(self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber)) {
            sendSellerConfirmEmail()
        }


        async.series(functionsToPerform,
            function (err, responses) {
                self.setState({pending: false});
                if (err) {
                    return
                }
                var   message='Payout completed'
                if (self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber) {
                    message = 'Payout processing action with ID ' + PayoutID + ' started. Confirmation email will be sent at ' + self.props.userReducer.user.email
                }

                self.props.displayMessage({
                    'messageType': 'success',
                    'messageCode': message
                });

                self.setState({displayGeneratePayoutBox: false, PayoutNote: ''});
                self.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
            })

        function sendSellerConfirmEmail() {

            functionsToPerform.push(function (done) {
                var methodData = {
                    "endpoint": "/transactions/confirm_payout",
                    not_display_success_message: true,
                    "type": 'post'
                };
                var params = {
                    payoutType:'WorkingTime',
                    totalPayout: totalPayout,
                    recordIDs: self.props.adminTransactions.selectedTransactions
                };
                if (self.state.PayoutNote) {
                    params.PayoutNote = self.state.PayoutNote
                }


                self.props.makeRequest(params, methodData).then(function (res) {
                    done(null)
                }).catch(err => {

                        self.props.displayMessage({
                            'messageType': 'warning',
                            messageCode: 'sellerPayoutConfirmationNotSent'
                        });


                    done(null)
                });
            })
        }

    }

    calculateTotalPayout() {
        var totalPayout = 0;
        _.forEach(this.props.adminTransactions.selectedTransactions, function (recordID, index) {
            var record = _.find(this.props.adminTransactions.data, function (transaction) {
                return transaction._id == recordID;
            })
            if (_.isUndefined(record)) {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Selected transaction is not found and not included in Total payout'
                });
            }

            if (record.Type == 'Sale') {
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Sale transaction can not be used on this page. Please, contact administrator to resolve this issue.'
                });
            } else if (record.Type == 'Credit') {
                totalPayout += formatNumbers.unformat(formatNumbers.toFixed(record.Amount, 2))
            } else if (record.Type == 'Fee' || record.Type == 'PickupFee') {
                totalPayout -= formatNumbers.unformat(formatNumbers.toFixed(record.Amount, 2))
            } else if (record.Type == 'Fee' || record.Type == 'WorkingTime') {
                totalPayout+= formatNumbers.unformat(formatNumbers.toFixed(record.Amount, 2))
            }
        }.bind(this));
        return totalPayout
    }

    validateAndGetFormData() {
        var formData = {}
        if (this.state.formData.Type == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Type field is required',
            });
            return false;
        }

        formData.Type = this.state.formData.Type;
        if (this.state.formData.Status == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Status field is required',
            });
            return false;
        }
        formData.Status = this.state.formData.Status;
        if (this.state.formData.Description == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Description field is required',
            });
            return false;
        }
        formData.Description = this.state.formData.Description;


        if (this.state.formData.Amount == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Amount field is required',
            });
            return false;
        }

        formData.Amount = this.state.formData.Amount;
        if (!this.state.currentRecordID && formData.Type == 'Sale' && typeof this.state.formData.selectedProduct !== 'string') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, select a product',
            });
            return false;
        }
        if (typeof this.state.formData.selectedProduct == 'string') {
            formData.ProductID = this.state.formData.selectedProduct;
        }
        if (!this.state.currentRecordID) { /* this is new transaction*/
            formData.ContractorID = this.state.ContractorID ? this.state.ContractorID : (this.state.formData.Seller ? this.state.formData.Seller : false)
            if (!formData.ContractorID) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, select a seller',
                });
                return false;
            }
            formData.FulfilledAt = new Date()
        }
        return formData
    }

    closeModal() {
        this.setState({
            showAddFeeModal: false,
            currentRecordID: false,
            formData: {
                Description: '',
                Seller: false,
                Status: '',
                Type: '',
                Amount: '',
                selectedProduct: {},
                sellerProducts: [],
            }
        });
    }

    onSortChange(field, sortOrder) {
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            if (this.refs.pagination) {
                this.refs.pagination.resetPagination();
            }
            this.search()
        })
    }



    generatePayout() {
        if (this.checkPaidTransactions()) {
            return false;
        }

        this.setState({displayGeneratePayoutBox: true})
    }

    saveRecord(e) {
        e.preventDefault();
        var formData = this.validateAndGetFormData();
        if (!formData) {
            return false;
        }

        var methodData
        if (this.state.currentRecordID) {
            methodData = {
                "endpoint": "/transactions/" + encodeURIComponent(this.state.currentRecordID),
                type: "patch",
                success_event: UPDATE_TRANSACTION,
                messageData: {'#1#': 'Transaction'},
                messageCode: 'recordUpdated'
            };
        } else {
            methodData = {
                "endpoint": "/transactions",
                type: "post",
                success_event: ADD_TRANSACTION,
                messageData: {'#1#': 'Transaction'},
                messageCode: 'recordAdded'
            };
        }


        this.props.makeRequest(formData, methodData).then(res => {
            this.setState({
                showAddFeeModal: false,
                currentRecordID: false,
                formData: {
                    Description: '',
                    Seller: false,
                    Status: '',
                    Type: '',
                    Amount: '',
                    selectedProduct: {},
                    sellerProducts: [],
                }

            })
        }).catch(err => {
        });

    }


    onFormSellerChange(option) {
        this.setState({'formData': {...this.state.formData, Seller: option.value}}, function () {
            var methodData = {
                'endpoint': '/products',
                'not_display_success_message': true,
            };
            this.props.makeRequest({
                ContractorID: this.state.formData.Seller,
                all: true,
                listingStatuses: ['Listings'],
                lookup :['ContractorID'],
                status: 'all'
            }, methodData).then(function (res) {
                this.setState({'formData': {...this.state.formData, sellerProducts: res.data.data}});
            }.bind(this));
        });
    }

    render() {

        var totalPayout = 0;
        if (this.props.adminTransactions.fetched && this.props.adminTransactions.total > 0 && this.state.ContractorID) {
            totalPayout = this.calculateTotalPayout();
        }

        var filteredStatusOptions

         if (this.state.formData.Type == 'Credit') {
            filteredStatusOptions = _.filter(config.transactionStatusMap, (option) => {
                return _.includes(['Sold', 'Paid'], option.value)
            })
        } else {
            filteredStatusOptions = config.transactionStatusMap
        }

        return (
            <div className="admin-transactions-page">

                <ContractorTransactionsActionsBox selectAllRecords={this.state.selectAllRecords}
                                        search={this.search.bind(this)}
                                        toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}    {...this.props} ></ContractorTransactionsActionsBox>
                {this.state.displayGeneratePayoutBox && this.state.ContractorID&&
                <div className="blue top20">
                    <h4 className="bold-text">Generate Payout</h4>
                    <Row className="pleft15 top15">
                        <Col className="top8" xs={12}>Payout Method
                            = {_.get(this.props.adminTransactions.data[0], ['ContractorID', 'PaymentMethod'], '')  } </Col>
                        {_.includes(['Check','Paypal'], _.get(this.props.adminTransactions.data[0], ['ContractorID', 'PaymentMethod'], '')) &&
                        <Col className="top8" xs={12}>Payout Account
                            = {_.get(this.props.adminTransactions.data[0], ['ContractorID', 'PaymentMethod'], '') == 'Check' ?
                                _.get(this.state.selectedUser, ['UserID', 'firstName'], '') + ' ' + _.get(this.state.selectedUser, ['UserID', 'lastName'], '') :
                                _.get(this.props.adminTransactions.data[0], ['ContractorID', 'PaymentData', _.get(this.props.adminTransactions.data[0], ['ContractorID', 'PaymentMethod'], ''), 'email'], '')
                            }</Col>
                        }
                        <Col className="top8" xs={12}><span className="right10">Payout Amount</span>
                            <span
                                className="green">{((totalPayout == 0 ? '' : totalPayout > 0 ? '+' : '-') + '$' + formatNumbers.toFixed(Math.abs(totalPayout), 2))}</span></Col>
                        <Col className="top8 pull-left" xs={6}>
                            <span>Internal Comment</span>

                            <span className="left10">
                        <FormControl style={{'display': 'inline', 'width': 'auto'}} type="text"
                                     onChange={(e) => this.setState({'PayoutNote': e.target.value})}
                                     value={this.state.PayoutNote }
                                     placeholder=""/>
                    </span>
                        </Col>
                        <Col className="top8" xs={12}>
                            <Checkbox onChange={(e) => this.setState({sendEmailToUser: !this.state.sendEmailToUser})}
                                      checked={this.state.sendEmailToUser} inline><span className="left5">Send Customer Invoice (via email)</span></Checkbox>
                        </Col>
                        <Col xs={12} className="top10">
                            <Button
                                disabled={this.props.adminTransactions.selectedTransactions.length == 0 || this.state.pending}
                                className="btn btn-primary" onClick={(e) => this.completePayout()}>
                                Complete Payout
                            </Button>
                        </Col>
                    </Row>
                </div>
                }
                <ContractorTransactionsSearchBox pending={this.state.pending}
                                                 ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            this.search()
                        }
                    } }
                    contractorsOptionsList={ this.state.contractorsOptionsList}
                    search={this.search.bind(this)}
                    resetSearch={this.resetSearch.bind(this)}
                    fetchSelectedUserData={this.fetchSelectedUserData.bind(this)}
                    toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}
                    foundSellersList={this.state.foundSellersList}
                    {...this.props} >
                </ContractorTransactionsSearchBox>
                {this.props.adminTransactions.fetched && this.state.selectedUser &&
                < Row className="top20 blue">
                    <Col xs={5} className="pull-left">
                        <div>{this.state.selectedUser.DisplayName}</div>
                        <div
                            className="top5">{this.state.selectedUser.UserID.firstName + (this.state.selectedUser.UserID.lastName ? ' ' + this.state.selectedUser.UserID.lastName : '') }</div>
                        <div className="underlineText top5">{this.state.selectedUser.UserID.email}</div>
                    </Col>

                </Row>
                }
                {this.props.adminTransactions.fetched &&
                <div>
                    {  this.props.adminTransactions.total == 0  ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Transactions')}</div> :
                        <div className="top20">
                            <div className="bot10">Total: <span
                                className="blue">{this.state.totalDuration}</span></div>

                            <ContractorTransactionsListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editTransaction={this.editTransaction.bind(this)}
                                unsubmitTimeLogs={this.unsubmitTimeLogs.bind(this)}
                                setSearchParams={this.setSearchParams.bind(this)}
                                search={this.search.bind(this)}  {...this.props}  ></ContractorTransactionsListTable>
                            {!this.state.ContractorID &&
                            <PaginationBox
                                ref={'pagination'}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                total={this.props.adminTransactions.fetched ? this.props.adminTransactions.total : 0}
                                search={this.search.bind(this)}>
                            </PaginationBox>
                            }
                        </div>}

                </div>
                }
                { this.props.adminTransactions.fetched 
                && this.props.adminTransactions.total > 0 
                && this.state.ContractorID &&
                <div className="pull-right">
                    <h3 className="green top5 right20 pull-left ">{(totalPayout == 0 ? '' : totalPayout > 0 ? '+' : '-') + ' $' + formatNumbers.toFixed(Math.abs(totalPayout), 2)  }</h3>
                    <button className="btn btn-primary left20"
                            onClick={  this.generatePayout.bind(this)}
                            disabled={this.props.adminTransactions.selectedTransactions.length == 0 || this.state.pending}
                            type="button">
                        Generate Payout
                    </button>
                </div>
                }


                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteTransaction() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {'adminTransactions': state.adminTransactions,allContractorsList:state.allContractorsList,
        userReducer: state.userReducer,
        allSellersList: state.allSellersList};

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsPage);
